module.exports = __webpack_public_path__ + "static/media/ios-chatbubbles.67cc3b7e.svg";